import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import classNames from 'classnames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISection from 'UIComponents/section/UISection';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
const I18N_PATH = 'ecosystem-marketplace-solutions-ui.storefront.providerServices';

function ServiceGridItem({
  illustrationName,
  textKey
}) {
  const {
    className: responsiveClassName
  } = useResponsiveProps({
    className: {
      xs: 'm-bottom-10',
      sm: undefined
    }
  });
  const computedClassName = classNames('text-center', responsiveClassName);
  return /*#__PURE__*/_jsx(UIGridItem, {
    size: {
      xs: 12,
      sm: 4
    },
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: computedClassName,
      direction: "column",
      align: "center",
      children: [/*#__PURE__*/_jsx(UIIllustration, {
        name: illustrationName,
        height: 120
      }), /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.services.${textKey}`
        })
      })]
    })
  });
}

export default function ServicesGrid() {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsxs(UIGrid, {
        className: "align-center",
        children: [/*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "content-strategy",
          textKey: "marketingServices"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "sales-professional",
          textKey: "salesEnablement"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "deals",
          textKey: "crmImplementation"
        })]
      })
    }), /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsxs(UIGrid, {
        className: "align-center",
        children: [/*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "marketing-templates",
          textKey: "websiteDesign"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "api",
          textKey: "appDevelopment"
        }), /*#__PURE__*/_jsx(ServiceGridItem, {
          illustrationName: "nps-question",
          textKey: "customerSuccessServices"
        })]
      })
    })]
  });
}